<template>
    <div class="report-builder-section-settings">
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label class="form-label">Required Data Sets</label>
                    <div class="dropdown">
                        <button class="btn form-select btn-field w-100" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
                        {{ (local_section.required_data_sets != null && local_section.required_data_sets.length > 0 ) ? getSelectedDataSetNames()  : 'Please Select' }}
                        </button>
                        <div class="dropdown-menu dropdown-menu-primary required-dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <div class="dropdown-item dropdown-item-checkbox d-flex align-items-center" v-for="item in data_set_types" :key="item.source_subtype" @click.prevent="changeDataSets(item.source_subtype)">
                                <input class="form-check-input required-dropdown-checkbox" type="checkbox" :checked="local_section.required_data_sets.includes(item.source_subtype)" readonly tabindex="-1" aria-label="Checkbox">
                                <span class="ms-2">
                                    {{ propercase(item.source_subtype) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label class="form-label">Required Integrations</label>
                    <div class="dropdown">
                        <button class="btn form-select btn-field w-100" type="button" id="dropdownMenuIntegrationsButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
                        {{ (local_section.required_integrations != null && local_section.required_integrations.length > 0) ? getSelectedIntegrationNames() : 'Please Select' }}
                        </button>
                        <div class="dropdown-menu dropdown-menu-primary required-dropdown-menu" aria-labelledby="dropdownMenuIntegrationsButton">
                            <div class="dropdown-item dropdown-item-checkbox d-flex align-items-center" v-for="item in integrations" :key="item.id" @click.prevent="changeIntegrations(item.id)">
                                <input class="form-check-input required-dropdown-checkbox" type="checkbox" :checked="isIntegrationRequired(item.id)" readonly tabindex="-1" aria-label="Checkbox">
                                <span class="ms-2">
                                    {{ item.display_name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <label class="form-label">Display Value Metric</label>
                <div class="input-group w-100 d-flex">
                    <accordion-select id="metrics-multi-select" :options="display_value_metric_options" 
                        v-model="local_section.display_value_metric_id" @input="updateSection" 
                        :field_name="'display_value_metric'" :show_hidden_fields="true" 
                        class="flex-grow-1"
                        :class="{ 'is-invalid': local_errors.display_value_metric_id !== '' }">
                    </accordion-select>
                    <button type="button" id="add-display-value-metric" class="btn btn-secondary"
                    data-bs-toggle="modal" :data-bs-target="'#add-section-metric-filter-modal-'+ section_index"
                    @click="addPageFilter('metric', 'display_value_metric')">
                        <i class="fas fa-plus" data-bs-toggle="tooltip"
                        title="Creating a new Metric option will add it to the Metrics option dropdown."></i>
                    </button>
                </div>
                <div class="text-danger invalid-feedback mb-3" v-if="local_errors.display_value_metric_id !== ''">
                    {{local_errors.display_value_metric_id}}
                </div>
            </div>

            <div class="col">
                <label class="form-label">Display Metric Name <i class="fas fa-question-circle info-icon" data-bs-toggle="tooltip" title="What title should describe the display value metric on the dashboard?"></i></label>
                <input type="text" id="section-display-name" class="form-control"
                    v-model="local_section.display_value_name" :class="{ 'is-invalid': local_errors.display_value_name !== '' }" @change="clearErrorForField('display_value_name')" aria-label="Display Value Name">
                <div class="text-danger invalid-feedback mb-3" v-if="local_errors.display_value_name !== ''">
                    {{local_errors.display_value_name}}
                </div>
            </div>

            <div class="col">
                <label class="form-label">Prioritization Metric</label>
                <div class="input-group w-100 d-flex">
                    <accordion-select id="metrics-multi-select" :options="prioritization_metric_options" 
                        v-model="local_section.prioritization_metric_id" @input="updateSection" 
                        :field_name="'prioritization_metric'" :show_hidden_fields="true" 
                        class="flex-grow-1"
                        :class="{ 'is-invalid': local_errors.prioritization_metric_id !== '' }">
                    </accordion-select>
                    <button type="button" id="add-prioritization-metric" class="btn btn-secondary"
                    data-bs-toggle="modal" :data-bs-target="'#add-section-metric-filter-modal-'+ section_index"
                    @click="addPageFilter('metric', 'prioritization_metric')">
                        <i class="fas fa-plus" data-bs-toggle="tooltip"
                        title="Creating a new Metric option will add it to the Metrics option dropdown."></i>
                    </button>                   
                </div>
                <div class="text-danger invalid-feedback mb-3" v-if="local_errors.prioritization_metric_id !== ''">
                    {{local_errors.prioritization_metric_id}}
                </div>                
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <nav>
                    <div class="d-flex align-items-center pt-3 px-2">            
                        <span class="py-1 ms-1 me-3 mb-0 h4 text-nowrap">Section Filters:</span>
                        <div class="input-group d-flex align-items-center">
                            <v-select :options="section_filter_options" placeholder="Select the Filter to add to Section..."
                                :searchable="true" class="searchable-select column-display w-50 custom-v-select"
                                :selectable="(option) => option.text !== ''"
                                label="text" @search="searchSectionFilterOption"
                                @update:modelValue="emitSectionFilterChange"
                                :filterable="false">
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes" style="width: 12px; line-height: 8px;"><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg></span>
                                </template>
                                <template #selected-option="{ text, category }">
                                    <span>{{"Select the Filter to add to Section..."}}</span>
                                </template>

                                <template #option="{ text, category }">
                                    <div class="suboption" :data-subcategory="category"
                                        :class="{ 'show': category === null || category === '' }">
                                        {{ text }}
                                    </div>
                                </template>
                                
                                <template #no-options="{ search, searching, loading }">
                                    <div class="suboption show">
                                        <em>No results found</em>
                                    </div>
                                </template>
                            </v-select>

                            <button class="btn btn-secondary" data-bs-toggle="modal" :data-bs-target="'#add-section-metric-filter-modal-'+ section_index" @click="addPageFilter('filter', 'section-filter')">
                                <i class="fa fa-plus"></i>
                            </button>                                 
                        </div>
                    </div>    
                        
                    <div class="d-flex py-2 px-2">
                        <span class="badge badge-primary me-2" v-for="(filter,index) in local_section.section_filters" :key="index">
                            &nbsp;{{ filter.admin_name }} <i class="fa fa-remove ms-2" id="remove-filter" @click="removeSectionFilterByIndex(index)"></i>
                        </span>
                    </div>
                </nav>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-12">
                <div class="mb-3">
                    <label class="form-label">Section Name</label>
                    <input type="text" id="section-title-input" class="form-control"
                        v-model="local_section.title" :class="{ 'is-invalid': local_errors.section_name !== '' }" @change="clearErrorForField('section_name')" aria-label="Section Name">
                    <div class="text-danger invalid-feedback" v-if="local_errors.section_name !== ''">
                        {{local_errors.section_name}}
                    </div>
                </div>
            </div>

            <div class="col-12">
                <label class="form-label">Description <em>(Optional)</em></label>
                <textarea id="section-description" class="form-control full-height" 
                v-model="local_section.description" ref="textarea" @input="resizeTextarea"></textarea>
            </div>
        </div>

        <div class="row mt-2">      
            <div class="col-12">
                <label class="form-label">Charts:</label>
                <div class="text-danger invalid-feedback" v-if="local_errors.if_has_primary_chart !== ''">
                    {{local_errors.if_has_primary_chart}}
                </div>
                
                <div v-if="local_section.charts && local_section.charts.length > 0" class="row chart-container">
                    <draggable :list="local_section.charts" :element="'div'" :tag="'div'" class="row" @end="onDragEnd" item-key="report_chart_id">
                        <template #item="{ element: chart, index: chart_index }">
                            <div class="chart-tile" :class="loadChartSize(chart_index)"> 
                                <div class="card mx-2 mb-4">
                                    <div class="card-body text-center tile-body p-0">
                                        <div class="row my-2">
                                            <div class="chart-content-row col-8 d-flex text-start">
                                                <i v-if="chart.type === 'scorecard'" class="mt-1 ms-3 fas fa-address-card"></i>
                                                <i v-if="chart.type === 'pie'" class="mt-1 ms-3 fas fa-chart-pie"></i>
                                                <i v-if="chart.type === 'line' || chart.type === 'bar_line' || chart.type === 'cumulative_line'" class="mt-1 ms-3 fas fa-chart-line"></i>
                                                <i v-if="chart.type === 'column' || chart.type === 'stacked_column' || chart.type === '100_percent_stacked_column'" class="mt-1 ms-3 fas fa-chart-column"></i>
                                                <i v-if="chart.type === 'horizontal_bar' || chart.type === 'stacked_bar' || chart.type === '100_percent_stacked_bar'" class="mt-1 ms-3 fas fa-chart-bar"></i>
                                                <i v-if="chart.type === 'table'" class="mt-1 ms-3 fas fa-table"></i>
                                                <i v-if="chart.type === 'information_card' && chart.title && !chart.title.toLowerCase().startsWith('divider')" class="mt-1 ms-3 fas fa-quote-left"></i>

                                                <div class="ms-3 w-100" v-if="chart.type !== 'information_card'">
                                                    <p class="mb-0">Title: <em>{{ chart.title }}</em>
                                                        <a v-if="chart.report_chart_id" :href="'/admin/chart_builder/' + chart.report_chart_id" 
                                                           class="ms-2 text-decoration-none" 
                                                           data-bs-toggle="tooltip" 
                                                           title="Open chart builder"
                                                           target="_blank"
                                                           @click.stop
                                                           @mousedown.stop>
                                                            <i class="fas fa-external-link-alt"></i>
                                                        </a>
                                                    </p>
                                                    <p class="mb-0">Subtitle: <em>{{ chart.subtitle }}</em></p>
                                                </div>
                                                <div v-else class="ms-3 w-100">
                                                    <p class="mb-0">Title: {{chart.title}}
                                                        <a v-if="chart.report_chart_id" :href="'/admin/chart_builder/' + chart.report_chart_id" 
                                                           class="ms-2 text-decoration-none" 
                                                           data-bs-toggle="tooltip" 
                                                           title="Open chart builder"
                                                           target="_blank"
                                                           @click.stop
                                                           @mousedown.stop>
                                                            <i class="fas fa-external-link-alt"></i>
                                                        </a>
                                                    </p>
                                                    <hr v-if="chart.type === 'information_card' && chart.title && chart.title.toLowerCase().startsWith('divider')">
                                                </div>
                                            </div>

                                            <div class="col-4">
                                                <div class="chart-button-row float-end me-1">
                                                    <button class="btn solid-border p-0" :class="{ 'btn-primary': chart.is_primary }" @click="setPrimaryChart(chart_index)"><i class="fas fa-star m-1"></i></button>
                                                    <button class="btn solid-border py-0 px-1" :class="{ 'btn-primary': chart.size === 'small' }" @click="selectChartSize(chart_index, 'small')">S</button>
                                                    <button class="btn solid-border py-0 px-1" :class="{ 'btn-primary': chart.size === 'medium' }" @click="selectChartSize(chart_index, 'medium')">M</button>
                                                    <button class="btn solid-border py-0 px-1" :class="{ 'btn-primary': chart.size === 'large' }" @click="selectChartSize(chart_index, 'large')">L</button>
                                                    <button class="btn solid-border py-0 px-1" :class="{ 'btn-primary': chart.size === 'x-large' }" @click="selectChartSize(chart_index, 'x-large')">XL</button>

                                                    <button class="btn solid-border p-0" data-bs-toggle="modal" :data-bs-target="'#update-chart-modal-'+ section_index" @click="editChart(chart_index)">
                                                        <img class="icon m-1" src="/img/icons/avid-icons/edit.svg" alt="">
                                                    </button>

                                                    <button class="btn solid-border p-0" @click="deleteChart(chart_index)"><i class="fa fa-trash m-1"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>

                <p v-else>No chart has been added to this section yet. Please click on the "Add Chart" button in the footer to add charts to the active section.</p>
            </div>
        </div>

        <div class="modal fade" :id="'add-section-metric-filter-modal-'+ section_index" aria-labelledby="add-section-metric-filter-modal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal" :data-bs-dismiss="'add-section-metric-filter-modal-'+ section_index"
                                 @click="closeModal('add-section-metric-filter-modal-'+ section_index)" data-bs-toggle="tooltip" title="Close">
                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2">{{ propercase(mf_type) }} Builder</h3>
                        </div>
                    </div>
                    <div class="modal-body pt-0 pb-0">
                        <metric-filter-builder 
                            :modal_id="'add-section-metric-filter-modal-'+ section_index" 
                            :data_blend="data_blend" ref="mf_builder" 
                            :client_id="page_client_id" 
                            :default_metric_format="default_metric_format" 
                            :type="mf_type" 
                            :clients="clients"
                            @update="sectionMetricFilterAdded"
                        ></metric-filter-builder>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" :id="'update-chart-modal-'+ section_index" aria-labelledby="update-chart-modal" data-bs-backdrop="static" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal" @click.prevent="closeModal('update-chart-modal-'+ section_index)">
                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2">Update Chart in {{ local_section.title ? local_section.title : 'New Section(unsaved)' }}</h3>
                        </div>
                    </div>
                    <div class="modal-body pt-0">
                        <section-chart-modal :modal_action="'Update'" :charts="charts" :section_chart="local_section.charts[this.chart_index_editing]" 
                        :section_index="section_index" @chartUpdated="updateChartInSection"></section-chart-modal>  
                    </div>
                </div>
            </div>   
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import vSelect from "vue3-select";
import draggable from 'vuedraggable';

export default defineComponent({
    name: 'ReportBuilderSectionSettings',
    components: {
        Swal,
        vSelect,
        draggable
    },
    props: {
        section_selected: {
            type: Object,
            required: true
        },
        clients: {
            type: Array,
            default: () => []
        },
        metrics_filters: {
            type: Array,
            required: true
        },
        charts: {
            type: Array,
            required: true
        },
        data_blend: {
            type: Object,
            required: false,
            default: null
        },
        data_set_types: {
            type: Array,
            required: true
        },
        integrations: {
            type: Array,
            default: () => []
        },
        section_errors: {
            type: Object,
            required: true
        },
        page_client_id: {
            type: [String, Number],
            required: false,
            default: null
        },
        section_index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            local_metrics_filters: [],
            section_filter_options: [],
            display_value_metric_options: [],
            prioritization_metric_options: [],
            mf_type: 'filter',
            mf_field_to_add: '',
            local_section: {},
            default_metric_format: null,
            chart_index_editing: null,
            form: {
                successful: false,
                busy: false,
                error: false
            },
            local_errors: {}
        };
    },
    watch: {
        section_selected: {
            handler(new_value) {
                this.local_section = this.section_selected;
                if (this.local_section.required_integrations == null) {
                    this.local_section.required_integrations = [];
                }
                this.loadSectionChartTypes();
                this.setupFilters();
            }
        },
        section_errors: {
            handler(new_value) {
                this.local_errors = this.section_errors;
            }
        }
    },
    beforeMount() {
        this.local_section = this.section_selected;
        if (this.local_section.required_integrations == null) {
            this.local_section.required_integrations = [];
        }
        this.loadSectionChartTypes();
        this.local_errors = this.section_errors;
        if (this.data_blend && this.data_blend.type === "constituent") {
            this.local_section.required_data_sets = ["constituents", "transactions"];
        }

        this.local_section.section_filters = [];
        this.local_metrics_filters = [...this.metrics_filters];
        this.section_filter_options = this.getAllSectionFilterOptions();
        this.display_value_metric_options = this.getDisplayValueMetricOptions();
        this.prioritization_metric_options = this.getPrioritizationMetricOptions();

        this.setupFilters();
        if (this.local_section.charts && this.local_section.charts.length > 1) {
            this.sortChartByOrder();
        }
    },
    methods: {
        sortChartByOrder(){
            this.local_section.charts = this.local_section.charts.sort(function(a, b){
                return a.order - b.order;
            });
        },
        loadSectionChartTypes(){ 
            if (this.local_section.charts && this.local_section.charts.length !== 0) {
                for(let i = 0; i < this.local_section.charts.length; i++) {
                    const chart_obj = this.charts.find(c => c.id === this.local_section.charts[i].report_chart_id);
                    this.local_section.charts[i].type = chart_obj.type;
                }
            }
        },
        //Translate the section filters into the UI equivalent
        setupFilters() {
            this.local_section.section_filters = [];
            if(this.section_selected.filters != null)
                this.section_selected.filters.forEach((filter)=>{
                    var obj = this.local_metrics_filters.find((mf)=>mf.id == filter.report_metrics_filters_id);
                    if(obj != null){
                        this.local_section.section_filters.push(obj);
                        this.section_filter_options = this.section_filter_options.filter(option => option.value != obj.id);
                    }
                });
        },
        getAllSectionFilterOptions(){
            var filter_list = [];
            this.local_metrics_filters.forEach((mf)=>{
                // push if the mf not in the selected list
                if (this.local_section.section_filters.indexOf(mf) < 0){
                    if(mf.type=='filter'){
                        filter_list.push({
                            category:"",
                            text: mf.admin_name,
                            type: mf.format,
                            value: mf.id,
                        })
                    }
                }
            });
            return filter_list;
        },
        getDisplayValueMetricOptions(){
            var metric_list = [];
            this.local_metrics_filters.forEach((mf)=>{
                if (this.display_value_metric_options.indexOf(mf) < 0){
                    if(mf.type=='metric'){
                        metric_list.push({
                            category:"",
                            text: mf.admin_name,
                            type: mf.format,
                            value: mf.id,
                        })
                    }
                }
            });
            return metric_list;
        },
        getPrioritizationMetricOptions(){
            var metric_list = [];
            this.local_metrics_filters.forEach((mf)=>{
                if (this.display_value_metric_options.indexOf(mf) < 0){
                    if(mf.type=='metric' && mf.format == 'percent'){
                        metric_list.push({
                            category:"",
                            text: mf.admin_name,
                            type: mf.format,
                            value: mf.id,
                        })
                    }
                }
            });
            return metric_list;
        },
        updateSection(){
            this.$emit('updateSection', this.local_section);
        },
        searchSectionFilterOption(searchKey){
            var option_list = this.getAllSectionFilterOptions();
            if(searchKey == "") 

                this.section_filter_options = option_list;
            else    
                this.section_filter_options = option_list.filter(option => option.text.toLowerCase().includes(searchKey.toLowerCase()));
        },
        emitSectionFilterChange(event){
            var filter_object = this.local_metrics_filters.find((filter)=>filter.id == event.value);
            this.local_section.section_filters.push(filter_object);
            this.section_filter_options = this.section_filter_options.filter(option => option.value != event.value);

            this.$emit('updateSection', this.local_section);
        },
        removeSectionFilterByIndex(index){
            this.local_section.section_filters.splice(index, 1);
            // reset option dropdown list
            this.section_filter_options = this.getAllSectionFilterOptions();
        },
        sectionMetricFilterAdded(mf) {
            this.local_metrics_filters.push(mf);

            // sort this.local_metric_filter
            this.local_metrics_filters.sort((a, b) => (a.admin_name.toLowerCase() > b.admin_name.toLowerCase()) ? 1 : -1);

            if(this.mf_type == 'filter'){ // add to section filter dropdown
                this.section_filter_options = this.getAllSectionFilterOptions();
            } else { // add to display_value_metric dropdown and prioritization_metric dropdown
                this.display_value_metric_options = this.getDisplayValueMetricOptions();
                this.prioritization_metric_options = this.getPrioritizationMetricOptions();
            }
            this.closeModal('add-section-metric-filter-modal-' + section_index);
        },
        clearErrorForField(field_name){
            this.local_errors[field_name] = '';
        },
        closeModal(modal_ID){
            var myModalEl = document.getElementById(modal_ID)
            var modal = bootstrap.Modal.getInstance(myModalEl)
            // this.$refs.mf_builder.setMetricFilter(null);
            modal.hide();
        },
        changeDataSets(dataset){
            const index = this.local_section.required_data_sets.indexOf(dataset);
            if (index >= 0){
                //remove from the array
                this.local_section.required_data_sets.splice(index, 1)
            } else {
                this.local_section.required_data_sets.push(dataset);
            }
            this.$emit('updateSection', this.local_section);
        },
        changeIntegrations(integrationId) {
            const id = String(integrationId);
            const list = [...(this.local_section.required_integrations || [])].map(String);
            const index = list.indexOf(id);
            if (index >= 0) {
                list.splice(index, 1);
            } else {
                list.push(id);
            }
            this.local_section.required_integrations = list;
            this.$emit('updateSection', this.local_section);
        },
        isIntegrationRequired(integrationId) {
            const list = this.local_section.required_integrations || [];
            const id = String(integrationId);
            return list.some((stored) => String(stored) === id);
        },
        getSelectedIntegrationNames() {
            const list = this.local_section.required_integrations || [];
            const names = list.map((id) => {
                const item = this.integrations.find((i) => String(i.id) === String(id));
                return item ? item.display_name : id;
            });
            return names.join(', ');
        }, 
        editChart(chart_index){
            this.chart_index_editing = chart_index;
        },
        updateChartInSection(section_chart_detail){
            this.local_section.charts[this.chart_index_editing].report_chart_id = section_chart_detail.chart_selected.id;
            this.local_section.charts[this.chart_index_editing].title = section_chart_detail.title;
            this.local_section.charts[this.chart_index_editing].subtitle = section_chart_detail.subtitle;
            this.closeModal('update-chart-modal-'+ section_chart_detail.section_index);
        },
        addPageFilter(option, field) {
            // this.$refs.mf_builder.setMetricFilter(null);
            this.mf_type = option;
            this.mf_field_to_add = field;

            if (field == 'prioritization_metric'){
                this.default_metric_format = 'percent';
            }
        },
        getSelectedDataSetNames(){
            var names = [];
            this.local_section.required_data_sets.forEach((datasets)=>{
                var name =  datasets.replaceAll("_", " ").replace( /\w\S*/g,
                    function(txt) {
                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                    });
                names.push(name);
            })
            return names.join(', ');
        },
        resizeTextarea() {
            var element = document.querySelectorAll('textarea')[0];
            if (element && element.style){
                element.style.height = '';
                element.style.height = Math.max(element.offsetHeight, element.scrollHeight) + "px";
            }        
            // this.$forceUpdate();                  
        },
        deleteChart(index){
            this.local_section.charts.splice(index, 1);
            this.$emit('updateSection', this.local_section);
        },
        selectChartSize(chart_index, size_selected){
            this.local_section.charts[chart_index].size = size_selected;
            this.$emit('updateSection', this.local_section);
            this.$forceUpdate();
        },
        loadChartSize(chart_index){
            switch (this.local_section.charts[chart_index].size) {
                case 'small':
                    return 'col-4';
                case 'medium':
                    return 'col-6';
                case 'large':
                    return 'col-8'
                case 'x-large':
                    return 'col-12'
                default:
                    return 'col';
            }
        },
        setPrimaryChart(chart_index){
            for(var i = 0; i < this.local_section.charts.length; i++){
                if(i == chart_index)
                    this.local_section.charts[i].is_primary = true;
                else
                    this.local_section.charts[i].is_primary = false;
            }
            this.clearErrorForField('if_has_primary_chart');
            this.$emit('updateSection', this.local_section);
        },
        onDragEnd(e) {
            //If they moved it...
            if(e.newIndex != e.oldIndex) {
                this.local_section.charts.forEach((chart, chart_index)=>{
                    chart.order = chart_index + 1;
                })
                this.$emit('updateSection', this.local_section);
            }
        }
    }
});
</script>

<style scoped>
.dropdown-item-checkbox {
    cursor: pointer;
}
.required-dropdown-checkbox {
    pointer-events: none;
}
</style>
